// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge_3aUbC","disabled":"Badge_disabled_JosBs"};